"use strict";
var GpmlUtilities = require("./gpml-utilities");
var PATHWAY_DEFAULTS = {
    attributes: {
        BoardHeight: {
            name: 'BoardHeight',
            value: 500
        },
        Name: {
            name: 'Name',
            value: 'Untitled Pathway'
        }
    }
};
function applyDefaults(gpmlElement, defaults) {
    GpmlUtilities.applyDefaults(gpmlElement, [PATHWAY_DEFAULTS, defaults]);
    return gpmlElement;
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGF0aHdheS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9wYXRod2F5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxnREFBa0Q7QUFFbEQsSUFBTSxnQkFBZ0IsR0FBRztJQUN4QixVQUFVLEVBQUU7UUFDWCxXQUFXLEVBQUU7WUFDWixJQUFJLEVBQUUsYUFBYTtZQUNuQixLQUFLLEVBQUUsR0FBRztTQUNWO1FBQ0QsSUFBSSxFQUFFO1lBQ0wsSUFBSSxFQUFFLE1BQU07WUFDWixLQUFLLEVBQUUsa0JBQWtCO1NBQ3pCO0tBQ0Q7Q0FDRCxDQUFDO0FBRUYsdUJBQThCLFdBQVcsRUFBRSxRQUFRO0lBQ2xELGFBQWEsQ0FBQyxhQUFhLENBQUMsV0FBVyxFQUFFLENBQUMsZ0JBQWdCLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztJQUN2RSxNQUFNLENBQUMsV0FBVyxDQUFDO0FBQ3BCLENBQUM7QUFIRCxzQ0FHQztBQUFBLENBQUMifQ==


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/pathway.js
// module id = 289
// module chunks = 0